import React from 'react'
import { PropTypes } from 'prop-types'
const AutoIcon = (props) => (
  <svg
    id="Layer_2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18.42 16.37"
    fill={props.fill ? props.fill : '#262626;'}
    width={props.width ? props.width : '30'}
    height={props.height ? props.height : '30'}
  >
    <g id="Layer_1-2">
      <path
        className="cls-1"
        d="m2.05,14.22v1.38c0,.22-.07.4-.22.55s-.33.22-.55.22h-.51c-.22,0-.4-.07-.55-.22s-.22-.33-.22-.55V7.32L2.17.77c.09-.24.23-.43.42-.56s.42-.2.68-.2h11.87c.26,0,.48.07.68.2s.34.32.42.56l2.17,6.55v8.29c0,.22-.07.4-.22.55s-.33.22-.55.22h-.54c-.22,0-.4-.07-.54-.22s-.2-.33-.2-.55v-1.38H2.05Zm.08-8.44h14.17l-1.41-4.25H3.53l-1.41,4.25Zm-.59,1.53v5.37-5.37Zm2.71,4.09c.4,0,.73-.13.99-.4s.4-.59.4-.98-.13-.74-.4-1.01c-.27-.28-.59-.42-.98-.42s-.74.14-1.01.42c-.28.28-.42.61-.42,1.01s.14.73.42.99c.28.26.61.4,1.01.4Zm9.96,0c.4,0,.74-.13,1.01-.4.28-.27.42-.59.42-.98s-.14-.74-.42-1.01c-.28-.28-.61-.42-1.01-.42s-.73.14-.99.42c-.26.28-.4.61-.4,1.01s.13.73.4.99.59.4.98.4Zm-12.66,1.28h15.35v-5.37H1.53v5.37Z"
      />
    </g>
  </svg>
)

export default AutoIcon

AutoIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
}
